import { render, staticRenderFns } from "./terms-of-use.vue?vue&type=template&id=7fc9b330&scoped=true&"
var script = {}
import style0 from "./terms-of-use.vue?vue&type=style&index=0&id=7fc9b330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc9b330",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
